// This is just an example,
// so you can safely delete all default props below

export default {
    back: 'Back',
    delete_account: 'Delete Account',
    title: 'Are you sure you want to delete your account?',
    description: 'Your tickets will still be valid as before.',
    failed: 'An error occurred.'
}
